import { DataBean } from "../DataBean";

export class WithBankingNote extends DataBean {


    public async createEgressDocumentWithBankingNote(idBankingAccount:any,idPaymentAccount:any,accountantDate:any,description:any,idEmployee:any,sessionID:any,officeID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createEgressDocumentWithBankingNote_Number_Number_java.util.Date_String_Number_Number_Number", [idBankingAccount,idPaymentAccount,accountantDate,description,idEmployee,sessionID,officeID]);
    }


}